import * as fromRangoMPActions from '../../../actions/Componentes/Modelos/RangoMP.actions';


export interface rangosMPState {
    proceso: string;
    loading: boolean;
    error: any;
}

const initialStaterangosMP: rangosMPState = {
    proceso: '',
    loading: false,
    error: null
};

export function rangosMPReducer(state = initialStaterangosMP, action: fromRangoMPActions.RangoMPActions): rangosMPState {
    switch (action.type) {
        case fromRangoMPActions.SET_RangoMP:
            return {
                ...state,
                proceso: 'SetRango',
                loading: true
            };

        case fromRangoMPActions.SET_RangoMP_SUCCESS:
            return {
                ...state,
                proceso: 'SuccesSetRango',
                loading: false
            };

        case fromRangoMPActions.SET_RangoMP_FAILURE:
            return {
                ...state,
                loading: false,
                proceso: 'FailureSetRango',
                error: action.error
            };
      default: {
        return state;
      }
    }
}
